import {MessageNode} from "../messageObject/MessageNode.ts";

const messageIdMapping: { [key: string]: MessageNode } = {};

export default messageIdMapping;